import {
  Component,
  OnDestroy,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';

import { IWizardSubContentComponent } from '../../../wizard.subcontent';

@Component({
  selector: 'sites-review-subcontent-html',
  templateUrl: './review.sub.content.html',
  styleUrls: ['../wizard.sites.style.scss', './review.sub.content.style.scss']
})
export class SitesReviewSubContentCommponent
  implements OnInit, OnDestroy, AfterViewInit, IWizardSubContentComponent {
  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;

  isUploadEnabled: boolean;
  siteImagePath: string;
  subnetsImagePath: string;
  wizardService: any;

  constructor() {}

  ngOnDestroy() {}

  ngAfterViewInit() {}

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.isUploadEnabled = this.wizardService.showUploadSites;
    this.siteImagePath = 'images/site.svg';
    this.subnetsImagePath = 'images/subnets.svg';
  }
}
